export default __webpack_public_path__ + "static/media/finger_print.09b63955.gif";